<!--
  ~ Copyright (C) Compliance Audit Systems Limited - All Rights Reserved
  ~ Unauthorised copying of this file, via any medium is strictly prohibited
  ~ Proprietary and confidential
  ~ Written by Sudara Fernando <sudara@complianceauditsystems.com>, ${DATE}
  ~
  -->

<h1 class="title">ACABIM Subscriptions</h1>
<h5>Manage subscriptions and seats</h5>
<acabim-admin-organisations-picker #organisationPicker></acabim-admin-organisations-picker>

<p-tabView orientation="right">
    <p-tabPanel header="Organisation User Subscriptions">
        <ng-template pTemplate="content">
            <acabim-admin-user-subscriptions-view [selectedOrganisation]="organisationPicker.selectedOrganisation"></acabim-admin-user-subscriptions-view>
        </ng-template>
    </p-tabPanel>

    <p-tabPanel header="Resource Subscriptions">
        <ng-template pTemplate="content">
            <acabim-admin-resource-subscriptions-view [selectedOrganisation]="organisationPicker.selectedOrganisation"></acabim-admin-resource-subscriptions-view>
        </ng-template>
    </p-tabPanel>
</p-tabView>

